{
  "No orders found for this selection": "Inga ordrar hittades i detta urval",
  "Building CSV...": "Skapar CSV",
  "Created": "Skapad",
  "Name": "Namn",
  "E-mail": "E-post",
  "e.g. jane.doe@company.com": "e.g. jane.doe@company.com",
  "Product": "Produkt",
  "State": "Status",
  "Pending": "Väntande",
  "Approved": "Godkända",
  "All Products": "Alla produkter",
  "Order History": "Orderhistorik",
  "No username found": "Hittade inget användarnamn",
  "No email found": "Hittade ingen e-post",
  "Something went wrong with this order. Contact system admin about it.": "Något gick snett. Kontakta support.",
  "Are you sure that you want to reject this user?": "Är du säker på att du vill neka denna användare?",
  "Are you sure that you want to approve this user?": "Är du säker på att du vill godkänna denna användare?",
  "Approve": "Godkänn",
  "Id": "Id",
  "User": "Användare",
  "All States": "Alla statusar",
  "Cancel": "Avbryt",
  "Review": "Granska",
  "Updated at": "Uppdaterad",
  "By user": "Av användare",
  "To state": "Till status",
  "found-total": "Hittade {{count}} order",
  "found-total_plural": "Hittade {{count}} ordrar",
  "No user with that e-mail found": "Ingen användare med den e-postadressen hittades",
  "Filter by Product": "Filtrera på produkt",
  "Filter by State": "Filtrera på status",
  "Filter by E-mail address": "Filtrera på e-postadress",
  "Expand": "Expandera",
  "Re-run registration?": "Försök omregistera order?",
  "Licenses": "Licenser"
}
